module.exports = __webpack_public_path__ + "img/cloud-hail-lightning-sun.55917e4c.svg";